export const getIdForComponentNotification = (componentName, type, context) => {
    return `${componentName}-${type.toLowerCase()}-${context}`;
};
//# sourceMappingURL=get-id-for-component-notification.js.map